module.exports = __webpack_public_path__ + "static/media/wangTeacher.2c08793c.png";